import React from 'react'
import { useTranslation } from 'i18n'
import './ServerError.scss'

const ServerError = ({ style, customMessage, level }) => {
  const { t } = useTranslation('shared')
  const levelClassVal = level || 'default'
  return (
    <span
      style={style}
      className={`server-error error-level--${levelClassVal}`}
    >
      {customMessage ? customMessage : t('serverError')}
    </span>
  )
}

export default ServerError
